import { render, staticRenderFns } from "./WvSteakHouseCocktailSection.vue?vue&type=template&id=2517a498&scoped=true"
import script from "./WvSteakHouseCocktailSection.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseCocktailSection.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseCocktailSection.vue?vue&type=style&index=0&id=2517a498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517a498",
  null
  
)

export default component.exports